/**
 * Defines common theme variables needed across multiple js partials
 *
 * @package Octapharma
 * @since   1.0.0
 */

/**
 * Breakpoint variables.
 *
 * You can pass your own array of breakpoint objects to match up with the
 * ones you have setup in your SASS files.
 *
 * @since 1.0.0
 *
 * @see ../global/breakpoints.js
 *
 * @type {Breakpoints}
 */
import { Breakpoints } from '../global/breakpoints';

export const breakpoints = new Breakpoints([
	{
		key: 'xxs',
		min: 320,
	},
	{
		key: 'xs',
		min: 480,
	},
	{
		key: 'sm',
		min: 768,
	},
	{
		key: 'md',
		min: 1025,
	},
	{
		key: 'lg',
		min: 1200,
		max: Infinity,
	},
	{
		key: 'menu',
		min: 1060,
		max: Infinity,
	},
]);

/**
 * Common elements referenced throughout the project.
 *
 * @since 1.0.0
 */
export const els = {
	html: document.documentElement,
	body: document.body,
	header: document.getElementById('js-site-header'),
	navContainer: document.getElementById('js-site-navigation'),
	mainMenu: document.querySelector('.main-menu'),
	navicon: document.getElementById('js-navicon'),
	naviconTrigger: document.getElementById('js-navicon-trigger'),
	utilities: document.querySelector('.utilities'),
};
